import { useAtomValue, useSetAtom } from "jotai";
import {
  batchesAtom,
  setBatchesAtom,
  addBatchAtom,
  updateBatchAtom,
  upsertBatchAtom,
  upsertBatchesAtom,
  subscribeToBatchAtom,
  pendingBatchesAtom,
  completedBatchesAtom,
  failedBatchesAtom,
  batchesCountAtom,
  getBatchByIdAtom,
  resetBatchStateAtom
} from "../../atoms/batches/batches";
import { Batch } from "../../types/batch";

type MaybeAsyncFn<T, G> = ((arg: T) => G) | ((arg: T) => Promise<G>);

export default function useBatchStoreShared() {
  // Get atom values
  const batches = useAtomValue(batchesAtom);
  const pendingBatches = useAtomValue(pendingBatchesAtom);
  const completedBatches = useAtomValue(completedBatchesAtom);
  const failedBatches = useAtomValue(failedBatchesAtom);
  const batchesCount = useAtomValue(batchesCountAtom);
  const getBatchById = useAtomValue(getBatchByIdAtom);

  // Get atom setters
  const setBatches = useSetAtom(setBatchesAtom);
  const addBatch = useSetAtom(addBatchAtom);
  const updateBatch = useSetAtom(updateBatchAtom);
  const upsertBatch = useSetAtom(upsertBatchAtom);
  const upsertBatches = useSetAtom(upsertBatchesAtom);
  const subscribeToBatch = useSetAtom(subscribeToBatchAtom);
  const resetBatchState = useSetAtom(resetBatchStateAtom);

  // Create subscribe function that matches the original API
  const subscribe = (batch: Batch, onStart: MaybeAsyncFn<Batch, void>, onComplete: MaybeAsyncFn<Batch, void>) => {
    subscribeToBatch({ batch, onStart, onComplete });
  };

  return {
    // State
    batches,
    pendingBatches,
    completedBatches,
    failedBatches,
    batchesCount,

    // Actions
    setBatches,
    addBatch,
    updateBatch,
    upsertBatch,
    upsertBatches,
    subscribe,
    resetBatchState,

    // Utilities
    getBatchById
  };
}
